// ----------------------------------------------------------------------- react
import { useRef, useState } from "react";

// ------------------------------------------------------------------- internos
import { ubicacionesDeExcel, bajar } from "../services/satelitalPosiciones";

/* Subir un Excel de internos y bajarlo con la ubicación actual de cada uno.
 *
 * ── DE DÓNDE SALIÓ ────────────────────────────────────────────────────────
 *
 * Leonel (Satelital), 23/09: *«subir un excel y después poder bajarlo con las
 * ubicaciones actuales»*. Hoy lo hace unidad por unidad. Nace porque, además,
 * la planilla de arribos y cortes no lo deja imprimir el listado entero.
 *
 * ── UNA SOLA PANTALLA ─────────────────────────────────────────────────────
 *
 * Se sube, FlotaBot resuelve la posición de cada interno con la misma fuente
 * que el mapa, y devuelve el mismo listado con patente, ubicación, coordenadas,
 * la hora de la última señal y de qué fuente salió. No hay paso de confirmar:
 * no escribe nada, sólo lee y devuelve.
 */
export default function SatelitalPosiciones({ titulo = "", sub = "" }) {
  const entrada = useRef(null);
  const [archivo, setArchivo] = useState(null);
  const [encima, setEncima] = useState(false);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState("");
  const [hecho, setHecho] = useState("");

  const tomar = (f) => {
    setArchivo(f);
    setError("");
    setHecho("");
  };
  const elegido = (e) => {
    const f = e.target.files?.[0];
    if (f) tomar(f);
  };
  const soltar = (e) => {
    e.preventDefault();
    setEncima(false);
    const f = e.dataTransfer.files?.[0];
    if (f) tomar(f);
  };

  const pedir = async () => {
    if (!archivo) return;
    setCargando(true);
    setError("");
    setHecho("");
    const r = await ubicacionesDeExcel(archivo);
    setCargando(false);
    if (!r.ok) {
      setError(r.mensaje || "No se pudo.");
      return;
    }
    bajar(r.blob, r.nombre);
    setHecho(`Listo — se bajó «${r.nombre}» con la ubicación de cada interno.`);
  };

  return (
    <div>
      {titulo && <h2 style={{ margin: "0 0 4px" }}>{titulo}</h2>}
      <p className="tk-meta">
        {sub && <><b>{sub}</b><br /></>}
        Subí un Excel con una <b>columna de internos</b> (los números de unidad)
        y te lo devuelvo con la <b>ubicación actual</b> de cada uno: patente,
        lugar, coordenadas, la hora de la última señal y de qué fuente salió. Es
        la misma posición que ves en el mapa.
      </p>

      <div
        className={"planilla-cajon" + (encima ? " planilla-cajon--encima" : "")}
        onDragOver={(e) => {
          e.preventDefault();
          setEncima(true);
        }}
        onDragLeave={() => setEncima(false)}
        onDrop={soltar}
      >
        <p className="planilla-cajon__txt">
          Arrastrá el Excel acá
          <br />
          <span className="tk-meta">o</span>
        </p>
        <button
          type="button"
          className="tk-boton"
          onClick={() => entrada.current?.click()}
        >
          Buscar en el equipo
        </button>
        <input
          ref={entrada}
          type="file"
          accept=".xlsx,.xlsm"
          onChange={elegido}
          hidden
          aria-label="Excel de internos"
        />
        {archivo && <p className="tk-meta">{archivo.name}</p>}
      </div>

      {archivo && !cargando && (
        <p>
          <button
            type="button"
            className="tk-boton tk-boton--fuerte"
            onClick={pedir}
          >
            Traer las ubicaciones
          </button>
        </p>
      )}

      {cargando && (
        <p className="tk-meta">
          Buscando la ubicación de cada unidad… (puede tardar unos segundos)
        </p>
      )}

      {error && (
        /* `suave` para que el aviso no se abra encima de todo el hub, igual que
           en SubirPlanilla / SubirCargas. */
        <div className="panel-aviso suave">
          <p>{error}</p>
        </div>
      )}

      {hecho && (
        <div className="panel-aviso suave">
          <h3>Listo</h3>
          <p>{hecho}</p>
          <p className="tk-meta">
            Los que no tienen señal reciente salen igual, con el motivo en la
            columna «Estado».
          </p>
        </div>
      )}
    </div>
  );
}
